/*@ngInject*/
const OrganizationMenuController = function ($rootScope, $scope, $element, $state, $stateParams, coreConstant, loadingBarHandler, localization, manageOrganizationMediator, formViewerConstant, organizationUtil) {

    $element.addClass('organizationMenu');

    this.navigationItemList = [];
    this.selectedItem = null;

    this.$onInit = function () {
        localization.getTranslations().then((translations) => {

            this.processList = function (formSummaries) {
                formSummaries = _.filter(formSummaries, organizationUtil.isValidNavigationItem);

                const groupedList = _.groupBy(formSummaries, function (formSummary) {
                    return _.get(translations, 'organization.manage.formTemplateType.' + formSummary.formTemplateType);
                });

                this.navigationItemList = [];
                if (formSummaries.length === 1) {
                    this.onMenuHasSingleItem();
                } else {
                    this.onMenuHasMultipleItems();
                }

                _.each(groupedList, (item) => {
                    let itemToPush, selectedChild = null;

                    if (item.length === 1) {
                        itemToPush = item[0];
                    } else {
                        itemToPush = {
                            name: _.get(translations, 'organization.manage.formTemplateType.' + item[0].formTemplateType),
                            children: item,
                            isOpen: false
                        };
                    }

                    if (!_.isNil(itemToPush)) {
                        if (!_.isNil(itemToPush.totalRequiredFieldCount)) {
                            itemToPush.requiredFieldCount = itemToPush.totalRequiredFieldCount;
                        }

                        let requiredFieldCount = 0;
                        if ($stateParams.formId) {
                            if (itemToPush.id && $stateParams.formId === itemToPush.id.toString()) {
                                this.selectedItem = itemToPush;
                            } else if (itemToPush.children) {
                                _.each(itemToPush.children, function (item) {
                                    if (!_.isNil(item.totalRequiredFieldCount)) {
                                        item.requiredFieldCount = item.totalRequiredFieldCount;
                                    }

                                    requiredFieldCount += item.requiredFieldCount;
                                    if (item.id && $stateParams.formId === item.id.toString()) {
                                        selectedChild = item;
                                    }
                                });
                                if (selectedChild) {
                                    this.selectedItem = selectedChild;
                                }
                                itemToPush.requiredFieldCount = requiredFieldCount;
                            }
                        } else if (itemToPush.children) {
                            _.each(itemToPush.children, function (item) {
                                if (!_.isNil(item.totalRequiredFieldCount)) {
                                    item.requiredFieldCount = item.totalRequiredFieldCount;
                                }

                                requiredFieldCount += item.requiredFieldCount;
                            });
                            itemToPush.requiredFieldCount = requiredFieldCount;
                        }

                        this.navigationItemList.push(itemToPush);
                    }
                });
            };
        });

        $scope.$on(coreConstant.event.UPDATE_ORGANIZATION, (event, result) => {
            if (result.id === this.organizationId) {
                this.getOrganizationForms();
            }
        });

        $scope.$on(formViewerConstant.event.FORM_DATA_READY, (event, fieldModel) => {
            this.getOrganizationForms();
        });

        $scope.$on(formViewerConstant.event.UPDATE_ROOT_FORM, (event, fieldModel) => {
            this.getOrganizationForms();
        });

        this.loadOrganizationForms();
    };

    this.onRequiredIndicatorClicked = function (event, navItem) {
        let isChangingState = false;
        if (navItem.children) {
            isChangingState = navItem.id !== this.selectedItem.id;
            _.each(navItem.children, function (item) {
                if (item.requiredFieldCount > 0) {
                    navItem = item;
                    return false;
                }
            });
        } else {
            isChangingState = navItem.id !== this.selectedItem.id;
        }

        this.onNavChildItemClick(navItem);
        if (isChangingState) {
            $rootScope.$broadcast('showNextRequiredFieldAfterFormLoad');
            $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD_AFTER_FORM_LOAD);
        } else {
            $rootScope.$broadcast('showNextRequiredField');
            $rootScope.$broadcast(formViewerConstant.event.SHOW_NEXT_REQUIRED_FIELD, navItem.id.toString());
        }
    };

    this.validatedSelectedItem = function () {
        function isItemInList(itemList, targetValue) {
            let result = false;

            _.each(itemList, (item) => {
                if (item.id === targetValue) {
                    result = true;
                } else if (item.children) {
                    result = isItemInList.call(this, item.children, targetValue);
                }
            });

            return result;
        }

        if (!this.selectedItem) {
            if (this.defaultSelectedValue) {
                this.selectedItem = _.find(this.navigationItemList, {id: this.defaultSelectedValue});
            } else {
                this.selectedItem = this.navigationItemList[0];
            }
        } else {
            const selectedItemExists = isItemInList.call(this, this.navigationItemList, this.selectedItem.id);

            if (!selectedItemExists) {
                this.selectedItem = this.navigationItemList[0];
            }
        }
    };

    this.onNavItemClick = function (itemValue) {
        const item = _.find(this.navigationItemList, function (navigationItem) {
            return navigationItem.id === itemValue;
        });

        if (!item.children) {
            this.notifyChange(item);
        }
    };

    this.onNavChildItemClick = function (item) {
        this.notifyChange(item);
    };

    this.notifyChange = function (item) {
        this.selectedItem = item;
        this.onSelectedItemChange({datasetItem: this.selectedItem});
    };

    this.hasChildren = function (item) {
        return !_.isEmpty(item.children);
    };

    this.isActive = function (childItem) {
        return this.defaultSelectedValue === parseInt(childItem.id);
    };

    this.isItemOpen = function (item) {
        let result = false;

        if (item.id === this.defaultSelectedValue && this.hasChildren(item)) {
            result = true;
        } else {
            _.each(item.children, (item) => {
                if (item.id === this.defaultSelectedValue) {
                    result = true;
                }
            });
        }
        return result;
    };

    this.getOrganizationForms = function () {
        return manageOrganizationMediator.getForms(this.organizationId).then((result) => {
            this.processList(result);
        });
    };

    this.loadOrganizationForms = function () {
        loadingBarHandler.showLoadingBar();
        this.getOrganizationForms().then(() => {
            this.validatedSelectedItem();
            if (this.selectedItem) {
                this.notifyChange(this.selectedItem);
            }
            loadingBarHandler.hideLoadingBar();
        });
    };
};

angular.module('ums.configuration')
    .controller('organizationMenuController', OrganizationMenuController);
